<template>
  <footer class="footer">
    <div class="footer-container">
      <!-- 線上方的四欄區域 - logo + 三個標題 -->
      <div class="footer-top-section">
        <div class="footer-top-columns">
          <div class="top-column logo-column">
            <img src="/footer_logo.webp" :alt="SITE_NAME" class="footer-logo" />
          </div>

          <div class="top-column social-column">
            <a
              v-if="footerInfo.fb_acc"
              :href="footerInfo.fb_acc"
              target="_blank"
              :title="`${SITE_NAME} Facebook 頁面`"
            >
              <span class="sr-only visually-hidden">Facebook 頁面</span>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_382_2380)">
                  <path
                    d="M12 0.283203C5.38323 0.283203 0 5.66643 0 12.2832C0 18.8995 5.38323 24.2832 12 24.2832C18.6163 24.2832 24 18.8995 24 12.2832C24 5.66643 18.6173 0.283203 12 0.283203ZM14.9843 12.7057H13.032V19.6642H10.139V12.7057H8.76388V10.2463H10.139V8.65555C10.139 7.51626 10.6804 5.73603 13.0586 5.73603L15.2023 5.74425V8.13159H13.6463C13.3931 8.13159 13.0329 8.25823 13.0329 8.80153V10.2468H15.2371L14.9843 12.7057Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_382_2380">
                    <rect
                      width="24"
                      height="24"
                      fill="white"
                      transform="translate(0 0.283203)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </a>
            <a
              v-if="footerInfo.twitter_acc"
              :href="footerInfo.twitter_acc"
              :title="`${SITE_NAME} Twitter 頁面`"
              target="_blank"
            >
              <span class="sr-only visually-hidden">Twitter 頁面</span>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_382_2382)">
                  <path
                    d="M12 0.283203C18.6272 0.283203 24 5.65601 24 12.2832C24 18.9104 18.6272 24.2832 12 24.2832C5.37281 24.2832 0 18.9104 0 12.2832C0 5.65601 5.37281 0.283203 12 0.283203ZM10.4883 13.0664L5.10059 19.3281H6.31836L11.0283 13.8525L14.791 19.3281H18.8994L13.3125 11.1973L18.4502 5.22559H17.2324L12.7725 10.4102L9.20996 5.22559H5.10059L10.4883 13.0664ZM17.2334 18.4531H15.3633L6.75684 6.1416H8.62598L17.2334 18.4531Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_382_2382">
                    <rect
                      width="32"
                      height="32"
                      fill="white"
                      transform="translate(0 0.283203)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </a>
            <a
              v-if="footerInfo.youtube_acc"
              :href="footerInfo.youtube_acc"
              :title="`${SITE_NAME} YouTube 頁面`"
              target="_blank"
            >
              <span class="sr-only visually-hidden">YouTube 頁面</span>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_382_2383)">
                  <path
                    d="M10.3359 14.2187L13.6644 12.2877L10.3359 10.3472V14.2187Z"
                    fill="white"
                  />
                  <path
                    d="M12 0.283203C9.62663 0.283203 7.30655 0.986991 5.33316 2.30557C3.35977 3.62414 1.8217 5.49829 0.913451 7.691C0.00519938 9.88372 -0.232441 12.2965 0.230582 14.6243C0.693605 16.9521 1.83649 19.0903 3.51472 20.7685C5.19295 22.4467 7.33115 23.5896 9.65892 24.0526C11.9867 24.5157 14.3995 24.278 16.5922 23.3698C18.7849 22.4615 20.6591 20.9234 21.9776 18.95C23.2962 16.9767 24 14.6566 24 12.2832C24 9.10061 22.7357 6.04836 20.4853 3.79792C18.2349 1.54749 15.1826 0.283203 12 0.283203ZM18.3158 14.4069C18.316 14.7207 18.2544 15.0316 18.1344 15.3216C18.0144 15.6116 17.8385 15.8751 17.6166 16.0971C17.3948 16.3192 17.1314 16.4953 16.8414 16.6154C16.5515 16.7356 16.2407 16.7974 15.9268 16.7974H8.07316C7.75931 16.7974 7.44853 16.7356 7.15859 16.6154C6.86864 16.4953 6.60522 16.3192 6.38336 16.0971C6.16151 15.8751 5.98557 15.6116 5.86561 15.3216C5.74565 15.0316 5.68401 14.7207 5.68422 14.4069V10.1595C5.68401 9.84567 5.74565 9.53485 5.86561 9.24482C5.98557 8.9548 6.16151 8.69126 6.38336 8.46926C6.60522 8.24726 6.86864 8.07115 7.15859 7.95099C7.44853 7.83084 7.75931 7.76899 8.07316 7.76899H15.9268C16.2407 7.76899 16.5515 7.83084 16.8414 7.95099C17.1314 8.07115 17.3948 8.24726 17.6166 8.46926C17.8385 8.69126 18.0144 8.9548 18.1344 9.24482C18.2544 9.53485 18.316 9.84567 18.3158 10.1595V14.4069Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_382_2383">
                    <rect
                      width="32"
                      height="32"
                      fill="white"
                      transform="translate(0 0.283203)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </a>
            <a
              v-if="footerInfo.line_acc"
              :href="footerInfo.line_acc"
              :title="`${SITE_NAME} Line 頁面`"
              target="_blank"
            >
              <span class="sr-only visually-hidden">Line 頁面</span>
              <svg
                width="24"
                height="24"
                viewBox="0 0 32 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16 32.5C24.8365 32.5 32 25.3365 32 16.5C32 7.66346 24.8365 0.5 16 0.5C7.16346 0.5 0 7.66346 0 16.5C0 25.3365 7.16346 32.5 16 32.5ZM15.9972 7.19991C21.2724 7.19991 25.5769 10.5056 25.8154 14.6545C25.8317 14.9088 25.8349 15.1638 25.8249 15.4185C25.811 15.6181 25.7851 15.8167 25.7473 16.0132C25.6239 16.7694 25.3696 17.4983 24.9957 18.1672C24.8198 18.4847 23.9578 19.6928 23.6934 20.011C22.2404 21.7615 19.8069 23.7819 15.7376 25.7455C15.6515 25.7873 15.5557 25.8053 15.4602 25.7975C15.3648 25.7898 15.2732 25.7566 15.1949 25.7014C15.1167 25.6462 15.0546 25.571 15.0153 25.4838C14.9759 25.3965 14.9606 25.3002 14.9711 25.205L15.1761 23.3595C15.184 23.2895 15.1779 23.2187 15.1583 23.1511C15.1387 23.0835 15.106 23.0204 15.0619 22.9655C15.0179 22.9106 14.9634 22.865 14.9016 22.8312C14.8399 22.7974 14.7721 22.7762 14.7021 22.7687C9.88547 22.2645 6.16804 18.9868 6.16804 15.018C6.16833 10.7001 10.5689 7.19991 15.9972 7.19991Z"
                  fill="white"
                />
                <path
                  d="M10.1698 16.8608H12.1337C12.2639 16.8608 12.3888 16.8091 12.4809 16.717C12.5729 16.625 12.6246 16.5001 12.6246 16.3699C12.6246 16.2397 12.5729 16.1148 12.4809 16.0228C12.3888 15.9307 12.2639 15.879 12.1337 15.879H10.6605V12.6629C10.6605 12.5327 10.6088 12.4079 10.5168 12.3158C10.4247 12.2237 10.2998 12.172 10.1696 12.172C10.0394 12.172 9.91456 12.2237 9.8225 12.3158C9.73043 12.4079 9.67871 12.5327 9.67871 12.6629V16.3698C9.67871 16.5 9.73045 16.6249 9.82254 16.717C9.91463 16.8091 10.0395 16.8608 10.1698 16.8608ZM15.3004 16.8608C15.4306 16.8608 15.5555 16.8091 15.6476 16.717C15.7397 16.6249 15.7914 16.5 15.7914 16.3698V14.1189C15.7914 14.1189 17.7821 16.6988 17.8118 16.7267C17.9014 16.8121 18.0202 16.86 18.1439 16.8608C18.277 16.8573 18.4034 16.8019 18.496 16.7063C18.5887 16.6107 18.6402 16.4827 18.6395 16.3496V12.6629C18.6379 12.5337 18.5855 12.4103 18.4935 12.3195C18.4016 12.2287 18.2776 12.1778 18.1484 12.1778C18.0191 12.1778 17.8951 12.2287 17.8032 12.3195C17.7113 12.4103 17.6588 12.5337 17.6573 12.6629V14.9275C17.6573 14.9275 15.6964 12.3699 15.6666 12.3363C15.6185 12.2823 15.559 12.2395 15.4924 12.2112C15.4258 12.1829 15.3537 12.1697 15.2814 12.1725C15.1522 12.1808 15.0312 12.2384 14.9433 12.3334C14.8555 12.4285 14.8076 12.5537 14.8095 12.6831V16.3698C14.8095 16.5 14.8612 16.6249 14.9533 16.7169C15.0453 16.809 15.1702 16.8608 15.3004 16.8608ZM13.4748 16.8608H13.6895C13.7399 16.8608 13.7898 16.8509 13.8363 16.8316C13.8829 16.8123 13.9252 16.784 13.9608 16.7483C13.9964 16.7127 14.0246 16.6703 14.0439 16.6238C14.0632 16.5772 14.0731 16.5273 14.073 16.4769V12.5555C14.073 12.4538 14.0326 12.3562 13.9607 12.2843C13.8888 12.2123 13.7912 12.1719 13.6895 12.1719H13.4748C13.373 12.1719 13.2755 12.2123 13.2035 12.2843C13.1316 12.3562 13.0912 12.4538 13.0911 12.5555V16.4769C13.0911 16.5273 13.101 16.5772 13.1203 16.6238C13.1396 16.6703 13.1678 16.7127 13.2034 16.7483C13.2391 16.784 13.2814 16.8123 13.3279 16.8316C13.3745 16.8509 13.4244 16.8608 13.4748 16.8608ZM19.8663 16.8608H21.8304C21.9606 16.8608 22.0854 16.8091 22.1775 16.717C22.2696 16.625 22.3213 16.5001 22.3213 16.3699C22.3213 16.2397 22.2696 16.1148 22.1775 16.0228C22.0854 15.9307 21.9606 15.879 21.8304 15.879H20.3573V15.0074H21.8302C21.9594 15.0058 22.0828 14.9534 22.1737 14.8615C22.2645 14.7696 22.3154 14.6455 22.3154 14.5163C22.3154 14.3871 22.2645 14.2631 22.1737 14.1711C22.0828 14.0792 21.9594 14.0268 21.8302 14.0252H20.3573V13.1537H21.8302C21.9604 13.1537 22.0852 13.102 22.1773 13.01C22.2693 12.9179 22.321 12.7931 22.321 12.6629C22.321 12.5328 22.2693 12.4079 22.1773 12.3159C22.0852 12.2239 21.9604 12.1722 21.8302 12.1722H19.8663C19.7361 12.1722 19.6113 12.2239 19.5193 12.3159C19.4272 12.408 19.3755 12.5328 19.3755 12.6629V16.3698C19.3755 16.4342 19.3882 16.4981 19.4128 16.5576C19.4375 16.6172 19.4736 16.6713 19.5192 16.7169C19.5648 16.7625 19.6189 16.7987 19.6784 16.8234C19.738 16.8481 19.8018 16.8608 19.8663 16.8608Z"
                  fill="white"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>

      <!-- 手機版可折疊選單 -->
      <div class="mobile-menu-section">
        <!-- 最新消息 -->
        <div class="mobile-menu-item">
          <div class="mobile-menu-header-static">
            <span
              ><router-link to="/activities">{{
                $t("footer.latestNews")
              }}</router-link></span
            >
          </div>
        </div>

        <!-- 簡介與沿革 -->
        <div class="mobile-menu-item">
          <div class="mobile-menu-header" @click="toggleMobileMenu('intro')">
            <span>{{ $t("footer.platformIntro") }}</span>
            <svg
              class="menu-arrow"
              :class="{ rotated: mobileMenus.intro }"
              width="12"
              height="9"
              viewBox="0 0 12 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.58677 7.88936L0.455999 2.23236L1.73846 0.818359L6.228 5.76836L10.7175 0.818359L12 2.23236L6.86923 7.88936C6.69915 8.07683 6.4685 8.18215 6.228 8.18215C5.9875 8.18215 5.75685 8.07683 5.58677 7.88936Z"
                fill="white"
              />
            </svg>
          </div>
          <div class="mobile-menu-content" v-show="mobileMenus.intro">
            <ul>
              <li>
                <router-link to="/minister-intro">{{
                  $t("footer.ministerIntro")
                }}</router-link>
              </li>
              <li>
                <router-link to="/vice-minister-intro">{{
                  $t("footer.viceMinisterIntro")
                }}</router-link>
              </li>
              <li>
                <router-link to="/director-intro">{{
                  $t("footer.directorIntro")
                }}</router-link>
              </li>
              <!-- <li>
                <router-link to="/expert-directory">{{
                  $t("footer.expertDirectory")
                }}</router-link>
              </li> -->
            </ul>
          </div>
        </div>

        <!-- SNOMED CT介紹 -->
        <div class="mobile-menu-item">
          <div class="mobile-menu-header" @click="toggleMobileMenu('snomed')">
            <span>{{ $t("footer.snomedCtIntro") }}</span>
            <svg
              class="menu-arrow"
              :class="{ rotated: mobileMenus.snomed }"
              width="12"
              height="9"
              viewBox="0 0 12 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.58677 7.88936L0.455999 2.23236L1.73846 0.818359L6.228 5.76836L10.7175 0.818359L12 2.23236L6.86923 7.88936C6.69915 8.07683 6.4685 8.18215 6.228 8.18215C5.9875 8.18215 5.75685 8.07683 5.58677 7.88936Z"
                fill="white"
              />
            </svg>
          </div>
          <div class="mobile-menu-content" v-show="mobileMenus.snomed">
            <ul>
              <li>
                <router-link to="/rxnorm/intro">{{
                  $t("footer.whatIsSnomedCt")
                }}</router-link>
              </li>
              <li>
                <router-link to="/rxnorm/education">{{
                  $t("footer.snomedCtEducation")
                }}</router-link>
              </li>
            </ul>
          </div>
        </div>

        <!-- 培訓認證 -->
        <div class="mobile-menu-item">
          <div class="mobile-menu-header" @click="toggleMobileMenu('training')">
            <span>{{ $t("footer.training") }}</span>
            <svg
              class="menu-arrow"
              :class="{ rotated: mobileMenus.training }"
              width="12"
              height="9"
              viewBox="0 0 12 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.58677 7.88936L0.455999 2.23236L1.73846 0.818359L6.228 5.76836L10.7175 0.818359L12 2.23236L6.86923 7.88936C6.69915 8.07683 6.4685 8.18215 6.228 8.18215C5.9875 8.18215 5.75685 8.07683 5.58677 7.88936Z"
                fill="white"
              />
            </svg>
          </div>
          <div class="mobile-menu-content" v-show="mobileMenus.training">
            <ul>
              <li>
                <router-link to="/workshop-courses">{{
                  $t("footer.workshopCourses")
                }}</router-link>
              </li>
              <li>
                <router-link to="/workshop-materials">{{
                  $t("footer.workshopMaterials")
                }}</router-link>
              </li>
            </ul>
          </div>
        </div>

        <!-- 臺灣標準 -->
        <div class="mobile-menu-item">
          <div
            class="mobile-menu-header"
            @click="toggleMobileMenu('standards')"
          >
            <span>{{ $t("footer.taiwanStandards") }}</span>
            <svg
              class="menu-arrow"
              :class="{ rotated: mobileMenus.standards }"
              width="12"
              height="9"
              viewBox="0 0 12 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.58677 7.88936L0.455999 2.23236L1.73846 0.818359L6.228 5.76836L10.7175 0.818359L12 2.23236L6.86923 7.88936C6.69915 8.07683 6.4685 8.18215 6.228 8.18215C5.9875 8.18215 5.75685 8.07683 5.58677 7.88936Z"
                fill="white"
              />
            </svg>
          </div>
          <div class="mobile-menu-content" v-show="mobileMenus.standards">
            <ul>
              <li>
                <router-link to="/standard-announcements">{{
                  $t("footer.standardAnnouncements")
                }}</router-link>
              </li>
            </ul>
          </div>
        </div>

        <!-- 術語搜尋 (暫時隱藏) -->
        <!-- <div class="mobile-menu-item">
          <div
            class="mobile-menu-header"
            @click="toggleMobileMenu('terminology')"
          >
            <span>{{ $t("footer.terminologySearch") }}</span>
            <svg
              class="menu-arrow"
              :class="{ rotated: mobileMenus.terminology }"
              width="12"
              height="9"
              viewBox="0 0 12 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.58677 7.88936L0.455999 2.23236L1.73846 0.818359L6.228 5.76836L10.7175 0.818359L12 2.23236L6.86923 7.88936C6.69915 8.07683 6.4685 8.18215 6.228 8.18215C5.9875 8.18215 5.75685 8.07683 5.58677 7.88936Z"
                fill="white"
              />
            </svg>
          </div>
          <div class="mobile-menu-content" v-show="mobileMenus.terminology">
            <ul>
              <li>
                <a href="#" target="_blank">{{
                  $t("footer.terminologyTaiwan")
                }}</a>
              </li>
              <li>
                <a href="#" target="_blank">{{
                  $t("footer.terminologyInternational")
                }}</a>
              </li>
            </ul>
          </div>
        </div> -->

        <!-- 支援中心 -->
        <div class="mobile-menu-item">
          <div class="mobile-menu-header-static">
            <span
              ><router-link to="/customer-service">{{
                $t("footer.supportCenter")
              }}</router-link></span
            >
          </div>
        </div>
      </div>

      <!-- 手機版聯絡資訊 -->
      <div class="mobile-contact-section">
        <div class="contact-info">
          <!-- 手機版支援表單按鈕 -->
          <div class="mobile-customer-service">
            <router-link to="/customer-service" class="customer-service-btn">
              <svg
                class="customer-service-icon"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path
                  d="M12 2C6.48 2 2 6.48 2 12c0 1.54.36 3 .97 4.29L1 23l6.71-1.97C9 21.64 10.46 22 12 22c5.52 0 10-4.48 10-10S17.52 2 12 2zm0 18c-1.41 0-2.73-.36-3.88-.99l-.28-.15-2.92.77.79-2.88-.17-.28C4.4 15.73 4 14.45 4 13c0-4.41 3.59-8 8-8s8 3.59 8 8-3.59 8-8 8zm4.54-6.14c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.12-.17.25-.64.81-.78.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43.12-.14.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.41-.42-.56-.43-.14 0-.31-.02-.48-.02-.17 0-.43.06-.66.31-.22.25-.86.84-.86 2.05s.88 2.38 1 2.56c.12.17 1.73 2.64 4.19 3.7.59.25 1.05.4 1.41.51.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.14-1.18-.07-.11-.25-.17-.53-.29z"
                />
              </svg>
              {{ $t("footer.customerService") }}
            </router-link>
          </div>
          <p v-if="footerInfo.phone" class="contact-item">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 122.9 98.9"
              xml:space="preserve"
              class="contact-icon"
              fill="currentColor"
              width="16"
              height="16"
            >
              <g>
                <path
                  class="st0"
                  d="M109,98.9H13.7v-14c0.5-16.3,14.9-28.7,23.6-42.8V29.7h14.5v8.9h19.5v-8.9h14.5v12.4 C95.2,57.2,109,67,109,84.7V98.9L109,98.9z M122.5,42.1c0-2.2,0.4-4.4,0.1-6.8c-10.7,3.5-21.1,2.5-31.3-3.1 c-0.4,3.8,0.2,7.2,1.6,10.4C96.5,50.6,122.2,53.3,122.5,42.1L122.5,42.1z M0.3,42.1c0-2.2-0.4-4.4-0.1-6.8 c10.7,3.5,21.1,2.5,31.3-3.1c0.4,3.8-0.2,7.2-1.6,10.4C26.3,50.6,0.5,53.3,0.3,42.1L0.3,42.1z M0,31.9C8.6-8.2,115.4-13,122.9,32 c-10.4,2.9-21,1.2-31.6-3.6c0.3-2.1-0.2-3.8-1.3-5.2c-6.3-7.9-51.4-8.2-57.2,0.3c-0.9,1.3-1.3,2.9-1.2,4.7 C21.1,34.6,10.5,36.1,0,31.9L0,31.9z M47.2,47.7c2.4,0,4.3,1.9,4.3,4.3c0,2.4-1.9,4.3-4.3,4.3c-2.4,0-4.3-1.9-4.3-4.3 C43,49.7,44.9,47.7,47.2,47.7L47.2,47.7z M74.8,71.7c2.4,0,4.3,1.9,4.3,4.3c0,2.4-1.9,4.3-4.3,4.3c-2.4,0-4.3-1.9-4.3-4.3 C70.5,73.7,72.4,71.7,74.8,71.7L74.8,71.7z M61,71.7c2.4,0,4.3,1.9,4.3,4.3c0,2.4-1.9,4.3-4.3,4.3c-2.4,0-4.3-1.9-4.3-4.3 C56.7,73.7,58.6,71.7,61,71.7L61,71.7z M47.2,71.7c2.4,0,4.3,1.9,4.3,4.3c0,2.4-1.9,4.3-4.3,4.3c-2.4,0-4.3-1.9-4.3-4.3 C43,73.7,44.9,71.7,47.2,71.7L47.2,71.7z M74.8,59.7c2.4,0,4.3,1.9,4.3,4.3c0,2.4-1.9,4.3-4.3,4.3c-2.4,0-4.3-1.9-4.3-4.3 C70.5,61.7,72.4,59.7,74.8,59.7L74.8,59.7z M61,59.7c2.4,0,4.3,1.9,4.3,4.3c0,2.4-1.9,4.3-4.3,4.3c-2.4,0-4.3-1.9-4.3-4.3 C56.7,61.7,58.6,59.7,61,59.7L61,59.7z M47.2,59.7c2.4,0,4.3,1.9,4.3,4.3c0,2.4-1.9,4.3-4.3,4.3c-2.4,0-4.3-1.9-4.3-4.3 C43,61.7,44.9,59.7,47.2,59.7L47.2,59.7z M74.8,47.7c2.4,0,4.3,1.9,4.3,4.3c0,2.4-1.9,4.3-4.3,4.3c-2.4,0-4.3-1.9-4.3-4.3 C70.5,49.7,72.4,47.7,74.8,47.7L74.8,47.7z M61,47.7c2.4,0,4.3,1.9,4.3,4.3c0,2.4-1.9,4.3-4.3,4.3c-2.4,0-4.3-1.9-4.3-4.3 C56.7,49.7,58.6,47.7,61,47.7L61,47.7z"
                />
              </g></svg
            >：
            {{ footerInfo.phone }}
          </p>
          <p v-if="footerInfo.email" class="contact-item">
            <svg
              class="contact-icon"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
              /></svg
            >：
            {{ footerInfo.email }}
          </p>
          <p v-if="footerInfo.address" class="contact-item">
            <svg
              class="contact-icon"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
              /></svg
            >：
            {{
              locale === "en-US"
                ? footerInfo.en_address || footerInfo.address
                : footerInfo.address
            }}
          </p>
          <div class="next-gen-social mobile-next-gen-social">
            <h4 class="next-gen-social-title">次世代計畫</h4>
            <div class="next-gen-social-buttons">
              <a
                v-for="link in nextGenSocialLinks"
                :key="`mobile-${link.key}`"
                :href="link.href"
                target="_blank"
                rel="noopener noreferrer"
                class="next-gen-social-btn"
                :class="link.className"
                :title="link.title"
                :aria-label="link.label"
              >
                <svg
                  v-if="link.key === 'facebook'"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.5 22V13.8077H16.2692L16.6846 10.6154H13.5V8.57692C13.5 7.65385 13.7538 7.03846 15.0769 7.03846H16.8V4.18462C15.9615 4.09231 15.1231 4 14.2846 4C11.7923 4 10.0385 5.53846 10.0385 8.3V10.6154H7.2V13.8077H10.0385V22H13.5Z"
                  />
                </svg>
                <svg
                  v-else-if="link.key === 'linkedin'"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.375 8.25C7.41053 8.25 8.25 7.41053 8.25 6.375C8.25 5.33947 7.41053 4.5 6.375 4.5C5.33947 4.5 4.5 5.33947 4.5 6.375C4.5 7.41053 5.33947 8.25 6.375 8.25Z"
                  />
                  <path d="M4.875 9.75H7.875V19.5H4.875V9.75Z" />
                  <path
                    d="M9.75 9.75H12.625V11.0813H12.6656C13.0657 10.3219 14.0438 9.525 15.5031 9.525C18.5438 9.525 19.125 11.5219 19.125 14.1188V19.5H16.125V14.7281C16.125 13.5938 16.1063 12.1406 14.5594 12.1406C12.9938 12.1406 12.75 13.3594 12.75 14.6438V19.5H9.75V9.75Z"
                  />
                </svg>
                <svg
                  v-else-if="link.key === 'youtube'"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.8 8.01875C21.8 8.01875 21.6063 6.64688 21.0125 6.04375C20.2594 5.25313 19.4156 5.25313 19.0313 5.20625C16.275 5 12.0062 5 12.0062 5C12.0062 5 7.72812 5 4.98125 5.20625C4.59687 5.25313 3.75312 5.25313 3 6.04375C2.40625 6.64688 2.2125 8.01875 2.2125 8.01875C2.2125 8.01875 2 9.63438 2 11.2406V12.7594C2 14.3656 2.2125 15.9813 2.2125 15.9813C2.2125 15.9813 2.40625 17.3531 3 17.9562C3.75312 18.7469 4.74375 18.7188 5.18438 18.8031C6.78125 18.9531 12.0062 19 12.0062 19C12.0062 19 16.275 18.9906 19.0313 18.7844C19.4156 18.7375 20.2594 18.7375 21.0125 17.9469C21.6063 17.3438 21.8 15.9719 21.8 15.9719C21.8 15.9719 22.0031 14.3656 22.0031 12.75V11.2312C22.0031 9.625 21.8 8.01875 21.8 8.01875ZM10.3906 14.5719V9.00625L15.7469 11.8031L10.3906 14.5719Z"
                  />
                </svg>
                <svg
                  v-else
                  aria-label="Threads"
                  viewBox="0 0 192 192"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                >
                  <path
                    d="M141.537 88.9883C140.71 88.5919 139.87 88.2104 139.019 87.8451C137.537 60.5382 122.616 44.905 97.5619 44.745C97.4484 44.7443 97.3355 44.7443 97.222 44.7443C82.2364 44.7443 69.7731 51.1409 62.102 62.7807L75.881 72.2328C81.6116 63.5383 90.6052 61.6848 97.2286 61.6848C97.3051 61.6848 97.3819 61.6848 97.4576 61.6855C105.707 61.7381 111.932 64.1366 115.961 68.814C118.893 72.2193 120.854 76.925 121.825 82.8638C114.511 81.6207 106.601 81.2385 98.145 81.7233C74.3247 83.0954 59.0111 96.9879 60.0396 116.292C60.5615 126.084 65.4397 134.508 73.775 140.011C80.8224 144.663 89.899 146.938 99.3323 146.423C111.79 145.74 121.563 140.987 128.381 132.296C133.559 125.696 136.834 117.143 138.28 106.366C144.217 109.949 148.617 114.664 151.047 120.332C155.179 129.967 155.42 145.8 142.501 158.708C131.182 170.016 117.576 174.908 97.0135 175.059C74.2042 174.89 56.9538 167.575 45.7381 153.317C35.2355 139.966 29.8077 120.682 29.6052 96C29.8077 71.3178 35.2355 52.0336 45.7381 38.6827C56.9538 24.4249 74.2039 17.11 97.0132 16.9405C119.988 17.1113 137.539 24.4614 149.184 38.788C154.894 45.8136 159.199 54.6488 162.037 64.9503L178.184 60.6422C174.744 47.9622 169.331 37.0357 161.965 27.974C147.036 9.60668 125.202 0.195148 97.0695 0H96.9569C68.8816 0.19447 47.2921 9.6418 32.7883 28.0793C19.8819 44.4864 13.2244 67.3157 13.0007 95.9325L13 96L13.0007 96.0675C13.2244 124.684 19.8819 147.514 32.7883 163.921C47.2921 182.358 68.8816 191.806 96.9569 192H97.0695C122.03 191.827 139.624 185.292 154.118 170.811C173.081 151.866 172.51 128.119 166.26 113.541C161.776 103.087 153.227 94.5962 141.537 88.9883ZM98.4405 129.507C88.0005 130.095 77.1544 125.409 76.6196 115.372C76.2232 107.93 81.9158 99.626 99.0812 98.6368C101.047 98.5234 102.976 98.468 104.871 98.468C111.106 98.468 116.939 99.0737 122.242 100.233C120.264 124.935 108.662 128.946 98.4405 129.507Z"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>

      <!-- 水平分隔線 -->
      <div class="footer-divider"></div>

      <!-- 線下方的四欄區域 -->
      <div class="footer-main-content">
        <div class="footer-columns">
          <div class="footer-column"></div>
          <!-- 最新消息 -->
          <div class="footer-column">
            <ul>
              <li>
                <router-link to="/activities"
                  ><h3 class="top-title">
                    {{ $t("footer.latestNews") }}
                  </h3></router-link
                >
              </li>
            </ul>
          </div>

          <!-- 簡介與沿革 -->
          <div class="footer-column">
            <ul>
              <li>
                <h3 class="top-title">{{ $t("footer.platformIntro") }}</h3>
              </li>
              <li>
                <router-link to="/minister-intro">{{
                  $t("footer.ministerIntro")
                }}</router-link>
              </li>
              <li>
                <router-link to="/vice-minister-intro">{{
                  $t("footer.viceMinisterIntro")
                }}</router-link>
              </li>
              <li>
                <router-link to="/director-intro">{{
                  $t("footer.directorIntro")
                }}</router-link>
              </li>
              <!-- <li>
                <router-link to="/expert-directory">{{
                  $t("footer.expertDirectory")
                }}</router-link>
              </li> -->
            </ul>
          </div>

          <!-- SNOMED CT介紹 -->
          <div class="footer-column">
            <ul>
              <li>
                <h3 class="top-title">{{ $t("footer.snomedCtIntro") }}</h3>
              </li>
              <li>
                <router-link to="/rxnorm/intro">{{
                  $t("footer.whatIsSnomedCt")
                }}</router-link>
              </li>
              <li>
                <router-link to="/rxnorm/education">{{
                  $t("footer.snomedCtEducation")
                }}</router-link>
              </li>
            </ul>
          </div>

          <!-- 培訓認證 -->
          <div class="footer-column">
            <ul>
              <li>
                <h3 class="top-title">{{ $t("footer.training") }}</h3>
              </li>
              <li>
                <router-link to="/workshop-courses">{{
                  $t("footer.workshopCourses")
                }}</router-link>
              </li>
              <li>
                <router-link to="/workshop-materials">{{
                  $t("footer.workshopMaterials")
                }}</router-link>
              </li>
            </ul>
          </div>

          <!-- 臺灣標準 -->
          <div class="footer-column">
            <ul>
              <li>
                <h3 class="top-title">{{ $t("footer.taiwanStandards") }}</h3>
              </li>
              <li>
                <router-link to="/standard-announcements">{{
                  $t("footer.standardAnnouncements")
                }}</router-link>
              </li>
            </ul>
          </div>

          <!-- 術語搜尋 (暫時隱藏) -->
          <!-- <div class="footer-column">
            <ul>
              <li>
                <h3 class="top-title">{{ $t("footer.terminologySearch") }}</h3>
              </li>
              <li>
                <a href="#" target="_blank">{{
                  $t("footer.terminologyTaiwan")
                }}</a>
              </li>
              <li>
                <a href="#" target="_blank">{{
                  $t("footer.terminologyInternational")
                }}</a>
              </li>
            </ul>
          </div> -->

          <!-- 支援中心 -->
          <div class="footer-column">
            <ul>
              <li>
                <h3 class="top-title">
                  <router-link to="/customer-service">{{
                    $t("footer.supportCenter")
                  }}</router-link>
                </h3>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- 社群媒體和無障礙標章獨立列 -->
      <div class="footer-bottom-row">
        <!-- 手機版logo -->
        <div class="footer-logo-mobile">
          <img src="/footer_logo.webp" :alt="SITE_NAME" class="footer-logo" />
        </div>
        <div class="footer-social-bottom">
          <!-- 第一欄 - 聯絡資訊和社群網站 -->
          <div class="footer-column contact-column">
            <div class="contact-info">
              <!-- 電腦版支援表單按鈕 -->
              <div class="desktop-customer-service">
                <router-link
                  to="/customer-service"
                  class="customer-service-btn"
                >
                  <svg
                    class="customer-service-icon"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path
                      d="M12 2C6.48 2 2 6.48 2 12c0 1.54.36 3 .97 4.29L1 23l6.71-1.97C9 21.64 10.46 22 12 22c5.52 0 10-4.48 10-10S17.52 2 12 2zm0 18c-1.41 0-2.73-.36-3.88-.99l-.28-.15-2.92.77.79-2.88-.17-.28C4.4 15.73 4 14.45 4 13c0-4.41 3.59-8 8-8s8 3.59 8 8-3.59 8-8 8zm4.54-6.14c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.12-.17.25-.64.81-.78.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-1.99-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.38.11-.51.11-.11.25-.29.37-.43.12-.14.17-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.41-.42-.56-.43-.14 0-.31-.02-.48-.02-.17 0-.43.06-.66.31-.22.25-.86.84-.86 2.05s.88 2.38 1 2.56c.12.17 1.73 2.64 4.19 3.7.59.25 1.05.4 1.41.51.59.19 1.13.16 1.56.1.48-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.14-1.18-.07-.11-.25-.17-.53-.29z"
                    />
                  </svg>
                  {{ $t("footer.customerService") }}
                </router-link>
              </div>
              <p v-if="footerInfo.phone" class="contact-item">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 122.9 98.9"
                  xml:space="preserve"
                  class="contact-icon"
                  fill="currentColor"
                  width="16"
                  height="16"
                >
                  <g>
                    <path
                      class="st0"
                      d="M109,98.9H13.7v-14c0.5-16.3,14.9-28.7,23.6-42.8V29.7h14.5v8.9h19.5v-8.9h14.5v12.4 C95.2,57.2,109,67,109,84.7V98.9L109,98.9z M122.5,42.1c0-2.2,0.4-4.4,0.1-6.8c-10.7,3.5-21.1,2.5-31.3-3.1 c-0.4,3.8,0.2,7.2,1.6,10.4C96.5,50.6,122.2,53.3,122.5,42.1L122.5,42.1z M0.3,42.1c0-2.2-0.4-4.4-0.1-6.8 c10.7,3.5,21.1,2.5,31.3-3.1c0.4,3.8-0.2,7.2-1.6,10.4C26.3,50.6,0.5,53.3,0.3,42.1L0.3,42.1z M0,31.9C8.6-8.2,115.4-13,122.9,32 c-10.4,2.9-21,1.2-31.6-3.6c0.3-2.1-0.2-3.8-1.3-5.2c-6.3-7.9-51.4-8.2-57.2,0.3c-0.9,1.3-1.3,2.9-1.2,4.7 C21.1,34.6,10.5,36.1,0,31.9L0,31.9z M47.2,47.7c2.4,0,4.3,1.9,4.3,4.3c0,2.4-1.9,4.3-4.3,4.3c-2.4,0-4.3-1.9-4.3-4.3 C43,49.7,44.9,47.7,47.2,47.7L47.2,47.7z M74.8,71.7c2.4,0,4.3,1.9,4.3,4.3c0,2.4-1.9,4.3-4.3,4.3c-2.4,0-4.3-1.9-4.3-4.3 C70.5,73.7,72.4,71.7,74.8,71.7L74.8,71.7z M61,71.7c2.4,0,4.3,1.9,4.3,4.3c0,2.4-1.9,4.3-4.3,4.3c-2.4,0-4.3-1.9-4.3-4.3 C56.7,73.7,58.6,71.7,61,71.7L61,71.7z M47.2,71.7c2.4,0,4.3,1.9,4.3,4.3c0,2.4-1.9,4.3-4.3,4.3c-2.4,0-4.3-1.9-4.3-4.3 C43,73.7,44.9,71.7,47.2,71.7L47.2,71.7z M74.8,59.7c2.4,0,4.3,1.9,4.3,4.3c0,2.4-1.9,4.3-4.3,4.3c-2.4,0-4.3-1.9-4.3-4.3 C70.5,61.7,72.4,59.7,74.8,59.7L74.8,59.7z M61,59.7c2.4,0,4.3,1.9,4.3,4.3c0,2.4-1.9,4.3-4.3,4.3c-2.4,0-4.3-1.9-4.3-4.3 C56.7,61.7,58.6,59.7,61,59.7L61,59.7z M47.2,59.7c2.4,0,4.3,1.9,4.3,4.3c0,2.4-1.9,4.3-4.3,4.3c-2.4,0-4.3-1.9-4.3-4.3 C43,61.7,44.9,59.7,47.2,59.7L47.2,59.7z M74.8,47.7c2.4,0,4.3,1.9,4.3,4.3c0,2.4-1.9,4.3-4.3,4.3c-2.4,0-4.3-1.9-4.3-4.3 C70.5,49.7,72.4,47.7,74.8,47.7L74.8,47.7z M61,47.7c2.4,0,4.3,1.9,4.3,4.3c0,2.4-1.9,4.3-4.3,4.3c-2.4,0-4.3-1.9-4.3-4.3 C56.7,49.7,58.6,47.7,61,47.7L61,47.7z"
                    />
                  </g></svg
                >：
                {{ footerInfo.phone }}
              </p>
              <p v-if="footerInfo.email" class="contact-item">
                <svg
                  class="contact-icon"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path
                    d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                  /></svg
                >：
                {{ footerInfo.email }}
              </p>
              <p v-if="footerInfo.address" class="contact-item">
                <svg
                  class="contact-icon"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path
                    d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
                  /></svg
                >：
                {{
                  locale === "en-US"
                    ? footerInfo.en_address || footerInfo.address
                    : footerInfo.address
                }}
              </p>
            </div>
          </div>
        </div>
        <div class="footer-next-gen-side">
          <div class="next-gen-social desktop-next-gen-social">
            <h4 class="next-gen-social-title">次世代計畫</h4>
            <div class="next-gen-social-buttons">
              <a
                v-for="link in nextGenSocialLinks"
                :key="`desktop-${link.key}`"
                :href="link.href"
                target="_blank"
                rel="noopener noreferrer"
                class="next-gen-social-btn"
                :class="link.className"
                :title="link.title"
                :aria-label="link.label"
              >
                <svg
                  v-if="link.key === 'facebook'"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.5 22V13.8077H16.2692L16.6846 10.6154H13.5V8.57692C13.5 7.65385 13.7538 7.03846 15.0769 7.03846H16.8V4.18462C15.9615 4.09231 15.1231 4 14.2846 4C11.7923 4 10.0385 5.53846 10.0385 8.3V10.6154H7.2V13.8077H10.0385V22H13.5Z"
                  />
                </svg>
                <svg
                  v-else-if="link.key === 'linkedin'"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.375 8.25C7.41053 8.25 8.25 7.41053 8.25 6.375C8.25 5.33947 7.41053 4.5 6.375 4.5C5.33947 4.5 4.5 5.33947 4.5 6.375C4.5 7.41053 5.33947 8.25 6.375 8.25Z"
                  />
                  <path d="M4.875 9.75H7.875V19.5H4.875V9.75Z" />
                  <path
                    d="M9.75 9.75H12.625V11.0813H12.6656C13.0657 10.3219 14.0438 9.525 15.5031 9.525C18.5438 9.525 19.125 11.5219 19.125 14.1188V19.5H16.125V14.7281C16.125 13.5938 16.1063 12.1406 14.5594 12.1406C12.9938 12.1406 12.75 13.3594 12.75 14.6438V19.5H9.75V9.75Z"
                  />
                </svg>
                <svg
                  v-else-if="link.key === 'youtube'"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.8 8.01875C21.8 8.01875 21.6063 6.64688 21.0125 6.04375C20.2594 5.25313 19.4156 5.25313 19.0313 5.20625C16.275 5 12.0062 5 12.0062 5C12.0062 5 7.72812 5 4.98125 5.20625C4.59687 5.25313 3.75312 5.25313 3 6.04375C2.40625 6.64688 2.2125 8.01875 2.2125 8.01875C2.2125 8.01875 2 9.63438 2 11.2406V12.7594C2 14.3656 2.2125 15.9813 2.2125 15.9813C2.2125 15.9813 2.40625 17.3531 3 17.9562C3.75312 18.7469 4.74375 18.7188 5.18438 18.8031C6.78125 18.9531 12.0062 19 12.0062 19C12.0062 19 16.275 18.9906 19.0313 18.7844C19.4156 18.7375 20.2594 18.7375 21.0125 17.9469C21.6063 17.3438 21.8 15.9719 21.8 15.9719C21.8 15.9719 22.0031 14.3656 22.0031 12.75V11.2312C22.0031 9.625 21.8 8.01875 21.8 8.01875ZM10.3906 14.5719V9.00625L15.7469 11.8031L10.3906 14.5719Z"
                  />
                </svg>
                <svg
                  v-else
                  aria-label="Threads"
                  viewBox="0 0 192 192"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                >
                  <path
                    d="M141.537 88.9883C140.71 88.5919 139.87 88.2104 139.019 87.8451C137.537 60.5382 122.616 44.905 97.5619 44.745C97.4484 44.7443 97.3355 44.7443 97.222 44.7443C82.2364 44.7443 69.7731 51.1409 62.102 62.7807L75.881 72.2328C81.6116 63.5383 90.6052 61.6848 97.2286 61.6848C97.3051 61.6848 97.3819 61.6848 97.4576 61.6855C105.707 61.7381 111.932 64.1366 115.961 68.814C118.893 72.2193 120.854 76.925 121.825 82.8638C114.511 81.6207 106.601 81.2385 98.145 81.7233C74.3247 83.0954 59.0111 96.9879 60.0396 116.292C60.5615 126.084 65.4397 134.508 73.775 140.011C80.8224 144.663 89.899 146.938 99.3323 146.423C111.79 145.74 121.563 140.987 128.381 132.296C133.559 125.696 136.834 117.143 138.28 106.366C144.217 109.949 148.617 114.664 151.047 120.332C155.179 129.967 155.42 145.8 142.501 158.708C131.182 170.016 117.576 174.908 97.0135 175.059C74.2042 174.89 56.9538 167.575 45.7381 153.317C35.2355 139.966 29.8077 120.682 29.6052 96C29.8077 71.3178 35.2355 52.0336 45.7381 38.6827C56.9538 24.4249 74.2039 17.11 97.0132 16.9405C119.988 17.1113 137.539 24.4614 149.184 38.788C154.894 45.8136 159.199 54.6488 162.037 64.9503L178.184 60.6422C174.744 47.9622 169.331 37.0357 161.965 27.974C147.036 9.60668 125.202 0.195148 97.0695 0H96.9569C68.8816 0.19447 47.2921 9.6418 32.7883 28.0793C19.8819 44.4864 13.2244 67.3157 13.0007 95.9325L13 96L13.0007 96.0675C13.2244 124.684 19.8819 147.514 32.7883 163.921C47.2921 182.358 68.8816 191.806 96.9569 192H97.0695C122.03 191.827 139.624 185.292 154.118 170.811C173.081 151.866 172.51 128.119 166.26 113.541C161.776 103.087 153.227 94.5962 141.537 88.9883ZM98.4405 129.507C88.0005 130.095 77.1544 125.409 76.6196 115.372C76.2232 107.93 81.9158 99.626 99.0812 98.6368C101.047 98.5234 102.976 98.468 104.871 98.468C111.106 98.468 116.939 99.0737 122.242 100.233C120.264 124.935 108.662 128.946 98.4405 129.507Z"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div class="footer-accessibility" v-if="false">
          <svg
            width="30"
            height="32"
            viewBox="0 0 30 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <rect
              x="0.180664"
              y="0.783203"
              width="29"
              height="31"
              fill="url(#pattern0_382_2385)"
            />
            <defs>
              <pattern
                id="pattern0_382_2385"
                patternContentUnits="objectBoundingBox"
                width="1"
                height="1"
              >
                <use
                  xlink:href="#image0_382_2385"
                  transform="matrix(0.0232558 0 0 0.0217554 0 -0.000375094)"
                />
              </pattern>
              <image
                id="image0_382_2385"
                width="43"
                height="46"
                preserveAspectRatio="none"
                xlink:href="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0aHBwgJC4nICIsIxwcKDcpLDAxNDQ0Hyc5PTgyPC4zNDL/2wBDAQkJCQwLDBgNDRgyIRwhMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjL/wAARCAAuACsDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwDx/wD4Q/U/71v/AN9n/Cj/AIQ/U/71v/32f8K0vDetX2o6jJDcyKyLEWACAc5A7fWur8t/L37G2H+LHFdMacJK6Pn6+PxdCfJK1zy7UtNn0u4WC4KF2TeNhyMZI/pWp/wh+p/3rf8A77P+FaPiXRdR1LU45bO0kmRYQrFccHLV1extm/aducbscZpRpJtpmlfMqkaUJQau73OD/wCEP1P+9b/99n/Cj/hD9T/vW/8A32f8K6zXbi4sNFmuoco427GK5B+YA/zrjf8AhKtW/wCe6f8Aftf8KUo04uzLw2IxuIhzw5fxND4evbx+KY3u0L2yqDMo/iTem4flmvoe3uHl1q/lvNbjGhzK6QGO7hMCRFSFUwk53D5cfL1HORwfnDwZ/wAhib/r3P8A6EtdXqWrWulxb53y5+7Gv3m/z604JOF2Z4yrKOK5Yq70/r0PSo5r648P6NH4a1OK1EMZ+2RC7WBxLnl3yRuU9uvSrM+oaXquuatogubZLW+gRluRhYhdoud4PQA8gkdfxrxnTdK8aeMba81XRNNuJLOyH/LEgDcOSFBIMjY7KCeRxyMppHiiK6K299iG46BjwrH+hoUot2FVw+IpU1K1+6+Vvy3Oq+Kl/Dc2U9lZOGsNPijtbcg8MFYbm/E5Oe/FeOV6J4n/AORduv8AgH/oa153UVlZpHXlU3OlKT7/AKI0NGury2vtlhA013cDyIkVCzFmIwFUdTkYA969t+H3wMnv5U1vxwGaOWPfHp3mMshJzgykYK4GCFBzyM4wVPofgD4TaH4FC3YP9oawN4N/Km3arcYRMkLwMZ5Jy3ODgd/Wd3ax6ChFScrasjgghtbeO3t4khgiQJHHGoVUUDAAA4AA7V598RvhHpPjkSahA32HXBHtS4UfJMRjaJRjJ4GNw5Ax1AAr0WikWfFXifTfEPhCW68N63CexikySrqGBDRt3U4/DoQCCK5WvuzXvD2k+J9LbTdZso7u0Zg+xiQQw6EMCCp6jII4JHQmvA9T/Zu1galcf2VrNi1hvzAbouJQvo21SMjpkdcZwM4Dbb3IjCML8qtc/9k="
              />
            </defs>
          </svg>

          <svg
            width="89"
            height="32"
            viewBox="0 0 89 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <rect
              x="0.180664"
              y="0.783203"
              width="88"
              height="31"
              fill="url(#pattern0_382_2386)"
            />
            <defs>
              <pattern
                id="pattern0_382_2386"
                patternContentUnits="objectBoundingBox"
                width="1"
                height="1"
              >
                <use
                  xlink:href="#image0_382_2386"
                  transform="scale(0.0113636 0.0322581)"
                />
              </pattern>
              <image
                id="image0_382_2386"
                width="88"
                height="31"
                preserveAspectRatio="none"
                xlink:href="data:image/jpeg;base64,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"
              />
            </defs>
          </svg>
        </div>
      </div>

      <!-- 頁尾底層資訊列與無障礙導盲磚 (Alt+Z) -->
      <div class="footer-bottom-bar">
        <div class="footer-bottom-left">
          <!-- 下方導覽磚 (Alt + Z)：低調水平平行於頁尾資訊，聚焦時清晰顯現 -->
          <a
            id="accesskey-z"
            href="#accesskey-z"
            accesskey="Z"
            class="accesskey-brick footer-brick"
            title="下方頁尾連結區塊，快捷鍵：Alt+Z"
            aria-label="下方頁尾連結區塊"
          >:::</a>
          <span class="copyright-text">版權所有 © 衛生福利部 資訊處保留所有權利</span>
        </div>
        <div class="footer-bottom-links">
          <router-link to="/sitemap" class="footer-link-item">網站地圖</router-link>
          <span class="link-divider">|</span>
          <router-link to="/privacy" class="footer-link-item">隱私權保護及資訊安全政策</router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { SITE_NAME } from "../constants/site";

export default {
  name: "FooterSection",
  setup() {
    const { locale } = useI18n();

    const mockupData = {
      address: "115204 台北市南港區忠孝東路6段488號",
      en_address:
        "No. 488, Section 6, Zhongxiao East Road, Nangang District, Taipei City 115204, Taiwan",
      phone: "(02)8590-6347",
      email: "med-standards@itri.org.tw",
      fb_acc: "https://www.facebook.com/mohw.gov.tw/",
      twitter_acc: "https://x.com/MOHW_Taiwan",
      youtube_acc: "https://www.mohw.gov.tw/cp-81-9463-1.html",
      line_acc: "https://www.mohw.gov.tw/cp-81-37724-1.html",
    };

    const footerInfo = ref(mockupData);

    const nextGenSocialLinks = [
      {
        key: "facebook",
        href: "https://www.facebook.com/profile.php?id=61584176884898",
        title: "次世代計畫 Facebook",
        label: "次世代計畫 Facebook",
        className: "facebook-btn",
      },
      {
        key: "linkedin",
        href: "https://www.linkedin.com/in/dhphello/",
        title: "次世代計畫 LinkedIn",
        label: "次世代計畫 LinkedIn",
        className: "linkedin-btn",
      },
      {
        key: "youtube",
        href: "https://www.youtube.com/channel/UCq4faIq5dri0n66RtLGRrWQ",
        title: "次世代計畫 YouTube",
        label: "次世代計畫 YouTube",
        className: "youtube-btn",
      },
      {
        key: "threads",
        href: "https://www.threads.com/@mohw_digital_health_platform",
        title: "次世代計畫 Threads",
        label: "次世代計畫 Threads",
        className: "threads-btn",
      },
    ];

    // 手機版選單開關狀態
    const mobileMenus = ref({
      intro: false,
      snomed: false,
      training: false,
      standards: false,
      terminology: false,
    });

    const toggleMobileMenu = (menuType) => {
      mobileMenus.value[menuType] = !mobileMenus.value[menuType];
    };

    return {
      footerInfo,
      nextGenSocialLinks,
      mobileMenus,
      toggleMobileMenu,
      locale,
      SITE_NAME,
    };
  },
};
</script>

<style scoped>
.footer {
  background-color: #022964;
  color: white;
  padding: 48px 24px 32px;
  font-size: 0.9em;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
}

/* 水平分隔線 */
.footer-divider {
  height: 1px;
  background-color: rgba(255, 255, 255, 0.2);
  margin: 32px 0;
}

/* 線上方的四欄區域 - logo 60% + 三欄 40% */
.footer-top-section {
  margin-bottom: 24px;
}

.footer-top-columns {
  display: grid;
  grid-template-columns: 50% 50%;
}

.logo-column {
  display: flex;
  align-items: flex-start;
}

.social-column {
  display: flex;
  justify-content: flex-end;
}

.footer-logo {
  height: 30px;
  width: auto;
}

.top-column {
  text-align: left;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  height: 100%;
  font-size: 16px;
  gap: 12px;
}

.top-column svg {
  width: 40px;
  height: 40px;
}

.top-title {
  font-weight: bold;
  color: white;
  margin: 0;
  font-size: 1em;
}

/* 線下方的四欄區域 - 對應上方結構 */
.footer-main-content {
  margin-bottom: 32px;
}

.footer-columns {
  display: grid;
  grid-template-columns: 14% 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  gap: 16px;
}

.footer-column ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.footer-column ul li {
  color: white;
  font-size: 16px;
}

.footer-column ul li a {
  color: white;
  text-decoration: none;
}

.footer-column ul li a:hover {
  text-decoration: underline;
}

/* 聯絡資訊樣式 - 文字靠下對齊，16px */
.contact-info {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  height: 100%;
}

.contact-info p {
  margin: 0 0 12px 0;
  color: white;
  font-size: 16px;
  line-height: 1.4;
}

.contact-info p:last-child {
  margin-bottom: 0;
}

.contact-item {
  display: flex;
  align-items: top;
  gap: 8px;
}

.contact-icon {
  flex-shrink: 0;
  color: white;
}

.next-gen-social {
  margin-top: 24px;
}

.next-gen-social-title {
  margin: 0 0 12px;
  color: white;
  font-size: 16px;
  font-weight: 700;
}

.next-gen-social-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.next-gen-social-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.16);
  color: white;
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.next-gen-social-btn svg {
  width: 20px;
  height: 20px;
}

.next-gen-social-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
  text-decoration: none;
}

.footer-next-gen-side {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  flex: 1;
  margin-left: 32px;
}

.desktop-next-gen-social {
  align-self: flex-start;
  margin-top: 0;
  text-align: right;
}

.footer-next-gen-side .desktop-next-gen-social {
  width: 100%;
}

.footer-next-gen-side .next-gen-social-buttons {
  justify-content: flex-end;
}

.mobile-next-gen-social {
  text-align: center;
}

.mobile-next-gen-social .next-gen-social-buttons {
  justify-content: center;
}

/* 社群媒體和無障礙標章獨立列 */
.footer-bottom-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 48px;
}

/* 手機版logo - 桌面版隱藏 */
.footer-logo-mobile {
  display: none;
}

.footer-social-bottom {
  display: flex;
  gap: 16px;
  align-items: center;
  flex: 1;
}

.footer-social-bottom img {
  width: 26px;
  height: 26px;
  transition: opacity 0.2s;
}

.footer-social-bottom a:hover img {
  opacity: 0.8;
}

.footer-accessibility {
  display: flex;
  align-items: center;
}

.footer-accessibility svg {
  margin-left: 32px;
}

.accessibility-logo {
  width: 150px;
  height: auto;
}

/* 手機版可折疊選單 */
.mobile-menu-section {
  display: none;
}

/* 手機版聯絡資訊 */
.mobile-contact-section {
  display: none;
  padding: 16px;
  text-align: center;
}

.mobile-social-buttons {
  display: none;
  justify-content: center;
  gap: 10px;
  margin-top: 40px;
}

.mobile-social-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  transition: background-color 0.3s ease;
}

.mobile-social-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.mobile-menu-item {
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.mobile-menu-item:first-child {
  border-top: none;
}

.mobile-menu-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  padding: 0 16px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.mobile-menu-header:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.mobile-menu-header span {
  font-size: 16px;
  font-weight: 500;
}

.mobile-menu-header-static {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 56px;
  padding: 0 16px;
}

.mobile-menu-header-static span {
  font-size: 16px;
  font-weight: 500;
}

.mobile-menu-header-static a {
  color: white;
  text-decoration: none;
}

.mobile-menu-header-static a:hover {
  text-decoration: underline;
}

.top-title a {
  color: white;
  text-decoration: none;
}

.top-title a:hover {
  text-decoration: underline;
}

.menu-arrow {
  transition: transform 0.3s ease;
  color: white;
}

.menu-arrow.rotated {
  transform: rotate(180deg);
}

.mobile-menu-content {
  background-color: rgba(0, 0, 0, 0.2);
  padding: 16px;
}

.mobile-menu-content ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.mobile-menu-content li {
  margin-bottom: 12px;
}

.mobile-menu-content li:last-child {
  margin-bottom: 0;
}

.mobile-menu-content a {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  font-size: 14px;
  transition: color 0.2s;
}

.mobile-menu-content a:hover {
  color: white;
  text-decoration: underline;
}

/* 所有連結樣式 */
.footer a {
  color: white;
  text-decoration: none;
}

.footer a:hover {
  text-decoration: underline;
}

/* RWD 手機 */
@media (max-width: 768px) {
  /* 隱藏桌面版的標題區域 */
  .footer-top-section {
    display: none;
  }

  /* 隱藏桌面版的水平分隔線 */
  .footer-divider {
    display: none;
  }

  /* 隱藏桌面版的主要內容區域 */
  .footer-main-content {
    display: none;
  }

  /* 顯示手機版選單 */
  .mobile-menu-section {
    display: block;
    margin-bottom: 32px;
  }

  /* 顯示手機版聯絡資訊 */
  .mobile-contact-section {
    display: block;
  }

  .mobile-social-buttons {
    display: flex;
  }

  .footer-top-columns,
  .footer-columns {
    grid-template-columns: 1fr;
    gap: 20px;
    margin: 0 auto;
    text-align: center;
    max-width: 100%;
  }

  .logo-column {
    display: none;
  }

  .top-column {
    text-align: center;
  }

  .contact-info {
    align-items: left;
    text-align: left;
  }

  .contact-info p {
    font-size: 14px;
    font-weight: 600;
  }

  .footer-bottom-row {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    margin-top: 32px;
  }

  /* 手機版顯示logo */
  .footer-logo-mobile {
    display: block;
  }

  .footer-logo-mobile .footer-logo {
    height: 40px;
    width: auto;
  }

  .footer-social-bottom {
    display: none;
  }

  .footer-next-gen-side {
    display: none;
  }

  .footer-accessibility {
    justify-content: flex-end;
  }

  .footer-accessibility svg {
    margin-left: 10px !important;
  }
}

@media (max-width: 480px) {
  .footer {
    padding: 32px 16px 24px;
  }

  .footer-top-columns,
  .footer-columns {
    gap: 16px;
  }

  .footer-logo {
    height: 50px;
  }

  .accessibility-logo {
    width: 120px;
  }

  .contact-info p {
    font-size: 14px;
  }
}

/* 客服支援按鈕樣式 */
.customer-service-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  text-decoration: none;
  border-radius: 25px;
  font-weight: 500;
  font-size: 14px;
  transition: all 0.3s ease;
  border: 2px solid rgba(255, 255, 255, 0.1);
  cursor: pointer;
  margin: 16px 0;
}

.customer-service-btn:hover {
  transform: translateY(-1px);
  text-decoration: none;
}

.customer-service-btn:active {
  transform: translateY(0);
}

.customer-service-icon {
  width: 16px;
  height: 16px;
  fill: currentColor;
}

/* 電腦版客服按鈕定位 */
.desktop-customer-service {
  margin-top: 20px;
}

/* 手機版客服按鈕置中 */
.mobile-customer-service {
  text-align: center;
  margin-top: 20px;
}

.mobile-customer-service .customer-service-btn {
  margin-top: 0;
}

/* 響應式調整 */
@media (max-width: 768px) {
  .desktop-customer-service {
    display: none;
  }
}

@media (min-width: 769px) {
  .mobile-customer-service {
    display: none;
  }
}
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

/* 頁尾底列樣式 */
.footer-bottom-bar {
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  font-size: 0.8125rem;
  color: rgba(255, 255, 255, 0.7);
}

@media (max-width: 768px) {
  .footer-bottom-bar {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}

.footer-bottom-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.footer-brick {
  color: rgba(255, 255, 255, 0.6) !important;
}

.footer-brick:focus-visible {
  outline: 2px solid #ffd700 !important;
  color: #ffd700 !important;
}

.footer-bottom-links {
  display: flex;
  align-items: center;
  gap: 10px;
}

.footer-link-item {
  color: rgba(255, 255, 255, 0.85);
  text-decoration: none;
  transition: color 0.2s;
}

.footer-link-item:hover,
.footer-link-item:focus-visible {
  color: #ffffff;
  text-decoration: underline;
}

.link-divider {
  color: rgba(255, 255, 255, 0.3);
}
</style>
